// extracted by mini-css-extract-plugin
module.exports = {"flight":"_1gcv-qjx6syM","flight_open":"_1oiFm_MOP1U_","flight__content":"QZRZclfaoHHM","fareGroups":"_3qv_jCDkzd6j"};